<script setup lang="ts"></script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <g clip-path="url(#clip0_454_2160)">
      <path
        d="M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z"
        fill="white"
        fill-opacity="0.3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.09038 11.4096C9.09038 10.1075 9.60765 8.85872 10.5284 7.93799C11.4491 7.01726 12.6979 6.5 14 6.5C15.3021 6.5 16.5509 7.01726 17.4716 7.93799C18.3924 8.85872 18.9096 10.1075 18.9096 11.4096C18.9096 12.7117 18.3924 13.9605 17.4716 14.8812C16.5509 15.802 15.3021 16.3192 14 16.3192C12.6979 16.3192 11.4491 15.802 10.5284 14.8812C9.60765 13.9605 9.09038 12.7117 9.09038 11.4096ZM5.00013 26.7985C5.03692 24.4359 6.0013 22.1825 7.6851 20.5247C9.3689 18.8669 11.6371 17.9377 14 17.9377C16.3629 17.9377 18.6311 18.8669 20.3149 20.5247C21.9987 22.1825 22.9631 24.4359 22.9999 26.7985C23.0027 26.9576 22.9591 27.114 22.8744 27.2487C22.7898 27.3834 22.6677 27.4904 22.5231 27.5568C19.8492 28.7828 16.9416 29.4155 14 29.4115C10.9604 29.4115 8.07246 28.7482 5.47691 27.5568C5.33233 27.4904 5.21023 27.3834 5.12556 27.2487C5.04088 27.114 4.99729 26.9576 5.00013 26.7985Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_454_2160">
        <path
          d="M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
